import React from "react";
import { observer } from "mobx-react";
import { EmailVerificationUpdateStore } from "../../store";
import { EmailVerificationUpdateForm } from "./EmailVerificationUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type EmailVerificationUpdateProps = {
  emailVerificationUpdateStore: EmailVerificationUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const EmailVerificationUpdate: React.FC<EmailVerificationUpdateProps> =
  observer(
    ({ emailVerificationUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={emailVerificationUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={emailVerificationUpdateStore.savedButOutdated}
            onReload={() =>
              emailVerificationUpdateStore.reloadEmailVerification()
            }
            reloadDisabled={emailVerificationUpdateStore.isProcessing}
          />
          <EmailVerificationUpdateForm
            emailVerificationUpdateStore={emailVerificationUpdateStore}
            emailError={emailVerificationUpdateStore.errors.email?.message}
            onEmailChange={(value: string) => {
              emailVerificationUpdateStore.setEmailValue(value);
            }}
            email={emailVerificationUpdateStore.entityValues.email}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={emailVerificationUpdateStore.saveDisabled}
            onSave={() => emailVerificationUpdateStore.saveEmailVerification()}
            onCancel={() =>
              emailVerificationUpdateStore.cancelEmailVerification()
            }
          />
          <ErrorDialog
            open={emailVerificationUpdateStore.errorDialogOpened}
            title={emailVerificationUpdateStore.errorTitle}
            description={emailVerificationUpdateStore.errorDescription}
            onClose={() => emailVerificationUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={emailVerificationUpdateStore.confirmDialogOpened}
            title={emailVerificationUpdateStore.confirmDialogTitle}
            description={emailVerificationUpdateStore.confirmDialogDescription}
            onConfirm={() =>
              emailVerificationUpdateStore.executeConfirmedAction()
            }
            onCancel={() => emailVerificationUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
